import * as React from "react";

import { formatCurrencyWithShopifyMoneyFormat } from "../liquid";
import { ShopifyStoreContext, useRuntimeContext } from "../runtime-context";

export function useShopifyMoneyFormat() {
  const {
    activeCurrency,
    activeLanguage,
    moneyFormat,
    moneyWithCurrencyFormat,
  } = useRuntimeContext(ShopifyStoreContext);

  return {
    moneyFormat,
    moneyWithCurrencyFormat,
    formatCurrency: React.useCallback<FormatCurrencyFunction>(
      (value, options) => {
        return formatCurrencyWithShopifyMoneyFormat(value, {
          ...options,
          moneyFormat,
          moneyWithCurrencyFormat,
          currencyCode: activeCurrency,
          language: activeLanguage,
        });
      },
      [moneyFormat, moneyWithCurrencyFormat, activeCurrency, activeLanguage],
    ),
  };
}

export type FormatCurrencyFunction = (
  value: string | number,
  options: {
    currencyCode: string;
    hideSymbol?: boolean;
    showCents?: boolean;
    showCurrencyCode?: boolean;
    zeroString?: string;
  },
) => string;
